import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {useSnackbar} from 'notistack';
import React, {useEffect} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import useReactRouter from 'use-react-router';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import getCmsCopy from '../getCmsCopy.api';
import {CmsCopy} from '../../../graphql/common.datatypes';
import CmsCopyEdit from './CmsCopyEdit';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
}));

const getBlankCmsCopy = (): CmsCopy => {
    return {
        __typename: 'CmsCopy',
        id: -1,
        key: '',
        body: '',
        is_html: false,
    };
};


const CmsCopyDetails = () => {
    const {history, match}: RouteComponentProps<{ id: string }> = useReactRouter();
    const classes = useStyles();
    const {id} = match.params;
    const newCmsCopy = id === 'new';
    const cmsCopyData = newCmsCopy ? {
        loading: false,
        data: {cmsCopy: getBlankCmsCopy()},
        error: null
    } : getCmsCopy(Number(id));
    const {enqueueSnackbar} = useSnackbar();
    const title = 'Cms Copy Details';

    useEffect(() => {
        if (cmsCopyData.error) {
            enqueueSnackbar(`There was an error loading Cms Copy ${id}`, {variant: 'error'});
            history.push('/cms_copy');
        }
    }, [cmsCopyData.error]);

    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="groups" title={title}/>
            <LoadingOverlay loading={cmsCopyData.loading}>
                {cmsCopyData.data && cmsCopyData.data.cmsCopy && (
                    <CmsCopyEdit cmsCopy={cmsCopyData.data.cmsCopy}/>)}
            </LoadingOverlay>
        </Page>
    );
};

export default CmsCopyDetails;
